// canvas 字体相关
import { getCanvasFontFacesCore } from '@meego/utils/src/styles/getCanvasFontFacesCore.ts';

export let GracefulDegradationFont =
  '"Inter", "PingFang SC", "Noto Sans SC", "Noto Sans JP", -apple-system, BlinkMacSystemFont, "Segoe UI", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif'; // 和主站 Semi 场景一致的 建议被 Canvas 组件使用的优雅降级字体

// ldp 为低分辨率下的 windows
export const updateGracefulDegradationFont = (
  preLang: 'zh' | 'ja' | 'watermark' | 'ldp' | 'jaldp',
) => {
  canvasFontFaces = updateFontFaces();
  switch (preLang) {
    case 'ja': {
      GracefulDegradationFont =
        '"Inter", "Noto Sans JP", "PingFang SC", "Noto Sans SC", "Inter", -apple-system, BlnkMacSystemFont, "Segoe UI", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif'; // 和主站 Semi 场景一致的 建议被 Canvas 组件使用的优雅降级字体
      return;
    }
    case 'jaldp': {
      GracefulDegradationFont =
        '"Inter", "Noto Sans JP", "PingFang SC", "Microsoft YaHei", -apple-system, BlinkMacSystemFont, "Segoe UI", "Hiragino Sans GB", "Helvetica Neue", Helvetica, Arial, sans-serif'; // 和主站 Semi 场景一致的 建议被 Canvas 组件使用的优雅降级字体
      return;
    }
    case 'ldp': {
      GracefulDegradationFont =
        '"Inter", "PingFang SC", "Microsoft YaHei", "Noto Sans JP", -apple-system, BlinkMacSystemFont, "Segoe UI", "Hiragino Sans GB", "Helvetica Neue", Helvetica, Arial, sans-serif'; // 和主站 Semi 场景一致的 建议被 Canvas 组件使用的优雅降级字体
      return;
    }
    case 'watermark': {
      GracefulDegradationFont = `"SHSCN-Normal0", ${GracefulDegradationFont}`;
      return;
    }
    default: {
      GracefulDegradationFont =
        '"Inter", "PingFang SC", "Noto Sans SC", "Noto Sans JP", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif'; // 和主站 Semi 场景一致的 建议被 Canvas 组件使用的优雅降级字体
      return;
    }
  }
};

/**
 * 改了字体必须同步修改injectRDKCoreScriptPlugin文件
 */
const updateFontFaces = (): {
  family: string;
  source: string;
  descriptors: FontFaceDescriptors;
}[] => {
  const { protocol } = location;
  // regular
  // const GeneralSansVariableFont: string = require('src/asset/font/GeneralSans/GeneralSansVariable-Regular.woff2?url');
  const urlMaker = (url: string) => (url.startsWith('https') ? url : protocol + url);

  const NotoSansSC: string = urlMaker(
    require('src/asset/font/NotoSansSC/NotoSansSC-Regular.otf?url'),
  );
  const NotoSansJP: string = urlMaker(
    require('src/asset/font/NotoSansJP/NotoSansJP-Regular.otf?url'),
  );
  const Inter: string = urlMaker(require('src/asset/font/Inter-Regular.woff2?url'));
  // medium
  // const GeneralSansVariableFontMedium: string = require('src/asset/font/GeneralSans/GeneralSansVariable-Medium.woff2?url');
  const NotoSansSCMedium: string = urlMaker(
    require('src/asset/font/NotoSansSC/NotoSansSC-Medium.otf?url'),
  );
  const NotoSansJPMedium: string = urlMaker(
    require('src/asset/font/NotoSansJP/NotoSansJP-Medium.otf?url'),
  );
  const InterMedium: string = urlMaker(require('src/asset/font/Inter-Medium.woff2?url'));
  const fontFaces = getCanvasFontFacesCore(Inter, InterMedium, NotoSansSC, NotoSansSCMedium, NotoSansJP, NotoSansJPMedium);

  return fontFaces;
};

export let canvasFontFaces = updateFontFaces();
